module.exports = __webpack_public_path__ + "style/img/weixin(1).46191f45.png";